import { jsx as _jsx } from "react/jsx-runtime";
import { Separator } from '../ui/separator.js';
export function Divider({ element }) {
    const { props } = element;
    const isVertical = props.vertical === true;
    return (_jsx(Separator, { orientation: isVertical ? 'vertical' : 'horizontal', className: isVertical ? 'mx-2 h-auto self-stretch' : 'my-2' }));
}
//# sourceMappingURL=Divider.js.map